import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
var DELIMITER = ',';
function decode(storedValue) {
  return storedValue.split(DELIMITER);
}
function encode(values) {
  return values.join(DELIMITER);
}
export function deleteStoredValue(key) {
  localStorage.removeItem(key);
}
export function getStoredValue(key) {
  var localValues = localStorage.getItem(key);
  if (localValues) {
    return decode(localValues);
  }
  return [];
}
export function hasStoredValue(key) {
  return localStorage.getItem(key) !== null;
}
export function storeValue(value, key) {
  var newValue = encode(value);
  localStorage.setItem(key, newValue);
}